import React, { useState, useEffect, useCallback } from 'react';
import * as Yup from 'yup';
import {
  HandleFormDetail,
  TextInput,
  ArrayInput,
  Selection,
  SimpleComboBox,
  FileUploadContract,
} from 'components';
import { Box, Button } from '@mui/material';
import { Formik } from 'formik';
import { PHONE_REG_EXP } from 'commons/constants';
import ApiServices from 'services';
import { SEX, RESPONSE_STATUSES } from 'commons/constants';

const SEX_OPTIONS = [
  { value: 0, content: SEX[0] },
  { value: 1, content: SEX[1] },
];

const FORM_WIDTH = '600px';
export const FormDetail = ({ selected, setSelected, reloadData, ...props }) => {
  const [clientCompanyId, setClientCompanyId] = useState('');
  const [file, setFile] = useState([]);
  const [currentFile, setCurrentFile] = useState([]);

  useEffect(() => {
    const currentArrUrlfile = selected?.arrUrlfile;

    if (selected?.clientCompanyId && !selected?.isNew) {
      setClientCompanyId(selected?.clientCompanyId);
    } else {
      setClientCompanyId('');
    }

    if (currentArrUrlfile?.length > 0) {
      setCurrentFile(currentArrUrlfile || []);
    } else {
      setCurrentFile([]);
    }
    setFile([]);
  }, [selected]);

  const handleChangeClient = (item) => {
    setClientCompanyId(item);
  };

  const createFn = async (values, { setSubmitting }) => {
    if (!clientCompanyId) {
      window.UIMessage?.error('Vui lòng chọn khách hàng !!!');
      setSubmitting(false);
      return;
    }

    if (!values?.phoneNumber && !values?.fax && file?.length < 1) {
      window.UIMessage?.error(
        'Vui lòng nhập dữ liệu cho 1 trong 3 mục sau:',
        'Số điện thoại, Ứng dụng liên hệ, File dữ liệu',
        5000,
      );
      setSubmitting(false);
      return;
    }

    const dataSend = {
      arrAddress: values?.arrAddress || [],
      birthday: values?.birthday,
      clientCompanyId: clientCompanyId,
      email: values?.email,
      fax: values?.fax,
      fullName: values?.fullName,
      nationality: values?.nationality,
      phoneNumber: values?.phoneNumber,
      religion: values?.religion,
      sex: values?.sex,
    };

    if (file?.length) {
      let tmp = file.map(([item]) => item);
      dataSend.files = tmp;
    }

    if (!dataSend.birthday) {
      delete dataSend.birthday;
    }

    setSubmitting(true);
    return ApiServices.createClientNew(dataSend)
      .then((res) => {
        if (res.status === RESPONSE_STATUSES.OK) {
          window.UIMessage?.success('Thêm mới thành công');
          setSelected(null);
          reloadData();
        }
      })
      .catch((err) => {
        window.UIMessage?.error('Thêm mới thất bại !!!');
        console.log(err);
      })
      .finally(() => setSubmitting(false));
  };

  const updateFn = async (values, { setSubmitting }) => {
    if (!clientCompanyId) {
      window.UIMessage?.error('Vui lòng chọn khách hàng !!!');
      setSubmitting(false);
      return;
    }

    if (!values?.phoneNumber && !values?.fax && file?.length < 1 && currentFile?.length < 1) {
      window.UIMessage?.error(
        'Vui lòng nhập dữ liệu cho 1 trong 3 mục sau:',
        'Số điện thoại, Ứng dụng liên hệ, File dữ liệu',
        5000,
      );
      setSubmitting(false);
      return;
    }
    // const fileTmp = file?.map(([item]) => item);
    const dataSend = {
      id: values?.id,
      arrAddress: values?.arrAddress || [],
      birthday: values?.birthday,
      clientCompanyId: clientCompanyId,
      email: values?.email,
      fax: values?.fax,
      fullName: values?.fullName,
      nationality: values?.nationality,
      phoneNumber: values?.phoneNumber,
      religion: values?.religion,
      sex: values?.sex,
      // files: fileTmp,
      arrUrlfile: currentFile || [],
    };

    if (file?.length) {
      let tmp = file.map(([item]) => item);
      dataSend.files = tmp;
    }

    if (!dataSend.birthday) {
      delete dataSend.birthday;
    }

    console.log('Update:::', { dataSend });

    setSubmitting(true);
    return ApiServices.updateClientNew(values.id, dataSend)
      .then((res) => {
        if (res.status === RESPONSE_STATUSES.OK) {
          window.UIMessage?.success('Cập nhật thành công');
          setSelected(null);
          reloadData();
        }
      })
      .catch((err) => {
        window.UIMessage?.error('Cập nhật thất bại !!!');
        console.log(err);
      })
      .finally(() => setSubmitting(false));
  };

  const handleChangeFile = useCallback(
    (e) => {
      setFile(e.target.value);
    },
    [file],
  );
  const handleChangeCurrentFile = useCallback(
    (fileCurrent) => {
      setCurrentFile(fileCurrent || []);
    },
    [currentFile],
  );

  return (
    <>
      <HandleFormDetail
        {...{ selected, setSelected, width: FORM_WIDTH }}
        showTitleTab={selected?.isNew ? 'Tạo mới' : `Mã: ${selected?.code}`}
      >
        <Formik
          initialValues={{
            // code: '',
            fullName: '',
            sex: '',
            nationality: '',
            religion: '',
            birthday: '',
            arrAddress: [],
            phoneNumber: '',
            fax: '',
            email: '',
            ...selected,
          }}
          validationSchema={Yup.object().shape({
            // code: Yup.string()
            //   .max(15, 'Mã chỉ được nhập tối đa 15 ký tự')
            //   .required('Vui lòng nhập mã KH!!!'),
            fullName: Yup.string().max(255).required('Vui lòng nhập tên người liên hệ!!!'),
            email: Yup.string().max(255).email('Email không hợp lệ'),
            sex: Yup.string().max(255).required('Vui lòng nhập giới tính'),
            // phoneNumber: Yup.string()
            //   .required('Vui lòng nhập số điện thoại')
            //   .matches(PHONE_REG_EXP, 'Số điện thoại không hợp lệ')
            //   .min(10, 'Số điện thoại có 10 ký tự')
            //   .max(10, 'Số điện thoại có 10 ký tự'),
          })}
          onSubmit={(values, { setSubmitting }) => {
            if (selected?.isNew) {
              createFn(values, { setSubmitting });
            } else {
              updateFn(values, { setSubmitting });
            }
          }}
        >
          {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              {!selected?.isNew && (
                <TextInput
                  // required
                  // error={Boolean(touched.code && errors.code)}
                  // helperText={touched.code && errors.code}
                  label="Mã"
                  name="code"
                  // onBlur={handleBlur}
                  // onChange={handleChange}
                  value={values.code}
                  disabled
                />
              )}

              <TextInput
                required
                error={Boolean(touched.fullName && errors.fullName)}
                helperText={touched.fullName && errors.fullName}
                label="Tên người liên hệ"
                name="fullName"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.fullName}
              />
              <SimpleComboBox
                label="Khách hàng (*)"
                disableClearable
                sx={{ marginY: '5px' }}
                value={clientCompanyId}
                keyValue="id"
                keyFieldView="name"
                renderLabel={(option) => `${option?.code} - ${option?.name}`}
                renderOption={(option) => (
                  <>
                    <span style={{ color: 'red' }}>{option?.code} </span> - {option?.name}
                  </>
                )}
                onChange={handleChangeClient}
                syncData={ApiServices.getClientCompanies}
              />

              <Selection
                error={Boolean(touched.sex && errors.sex)}
                helperText={touched.sex && errors.sex}
                label="Giới tính"
                name="sex"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.sex}
                dataArrObject={SEX_OPTIONS}
              />
              <TextInput
                error={Boolean(touched.nationality && errors.nationality)}
                helperText={touched.nationality && errors.nationality}
                label="Quốc tịch"
                name="nationality"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.nationality}
              />
              <TextInput
                error={Boolean(touched.religion && errors.religion)}
                helperText={touched.religion && errors.religion}
                label="Tôn giáo"
                name="religion"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.religion}
              />
              <TextInput
                error={Boolean(touched.birthday && errors.birthday)}
                helperText={touched.birthday && errors.birthday}
                label="Năm sinh"
                name="birthday"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.birthday}
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <ArrayInput
                value={values.arrAddress}
                fullWidth
                onChange={handleChange}
                label="Địa chỉ"
                name="arrAddress"
              />
              <TextInput
                // required
                // error={Boolean(touched.phoneNumber && errors.phoneNumber)}
                // helperText={touched.phoneNumber && errors.phoneNumber}
                label="Số điện thoại"
                name="phoneNumber"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.phoneNumber}
              />
              <TextInput
                error={Boolean(touched.fax && errors.fax)}
                helperText={touched.fax && errors.fax}
                label="Ứng dụng liên hệ"
                name="fax"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.fax}
              />
              <FileUploadContract
                sortFileName={true}
                label="File ứng dụng"
                name="file"
                onChange={handleChangeFile}
                value={file}
                multiple={true}
                isUploadOnlyContract={true}
                valueCurrent={currentFile}
                onChangeCurrent={handleChangeCurrentFile}
              />
              <TextInput
                // required
                // error={Boolean(touched.email && errors.email)}
                // helperText={touched.email && errors.email}
                label="Email"
                name="email"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.email}
              />
              <Box sx={{ py: 2 }}>
                <Button
                  color="primary"
                  disabled={isSubmitting}
                  fullWidth
                  size="small"
                  type="submit"
                  variant="contained"
                >
                  {selected?.isNew ? 'Thêm mới' : 'Cập nhật'}
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </HandleFormDetail>
    </>
  );
};
